import * as URLConfig from "@frameworks/web/config/domain";
import * as SJ_URLConfig from "@frameworks/salesjourney/config/domain";
import { microService } from "../SalesJourney/microServiceBase";
import { ElasticSearch } from "../SalesJourney/Clients/ClientsURL";
var config = URLConfig.config;
var base = config.jmw_market_env + "app-search/search/v2/";
var faqBase = config.jmw_market_env + "app-search/search/";
export default {
    optionChainTool: config.jmw + base + "optionchain",
    genTrending: config.jmw + base + "trending-and-recent",
    saveTrending: config.jmw + base + "trending-and-recent",
    genSearch: config.jmw + base,
    eqSearch: config.jmw + base + "equity",
    fuSearch: config.jmw + base + "futures",
    opSearch: config.jmw + base + "options",
    cuSearch: config.jmw + base + "currencies",
    comSearch: config.jmw + base + "commodities",
    curFut: config.jmw + base + "cur-fut",
    curOpt: config.jmw + base + "cur-opt",
    comfut: config.jmw + base + "com-fut",
    comopt: config.jmw + base + "com-opt",
    etfsSearch: config.jmw + base + "etfs",
    indSearch: config.jmw + base + "indices",
    pmSearch: config.jmw + base + "primary-markets",
    ncdsSearch: config.jmw + base + "ncds",
    mfSearch: config.jmw + base + "mutualfunds",
    sgbSearch: config.jmw + base + "sgb",
    corpFdSearch: config.jmw + base + "corpFd",
    wlSearch: config.jmw + base,
    deleteRecent: config.jmw + base + "recent",
    putAllRecent: config.jmw + base + "recent/all",
    faqSearch: config.jmw + faqBase + "faq",
    mfSearchNew: "".concat(SJ_URLConfig.config.apiBaseElasticSearch).concat(microService.masterSevice).concat(ElasticSearch, "MfProduct"),
};
